import { Component, OnInit, ViewChild, enableProdMode } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { DxDataGridComponent, DxScrollViewComponent, DxDataGridModule, DxSelectBoxComponent, DxCheckBoxModule, DxTemplateModule } from 'devextreme-angular';
import { SolicitudModificacionService } from '../../../services/formulacion/solicitud-modificacion.service';
import { switchMap } from 'rxjs/operators';
import { UtilHelper } from '../../../_helpers/util';
import { environment } from '../../../../environments/environment';
import { FusService, GeneralService, ReversionService } from '../../../services/service.index';
import { ElementSchemaRegistry } from '@angular/compiler';

declare var jQuery: any;
declare var toastr;

@Component({
  selector: 'app-solicitud-modificacion',
  templateUrl: './solicitud-modificacion.component.html',
  styles: [],
  providers: [SolicitudModificacionService]
})
export class SolicitudModificacionComponent implements OnInit {
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;
  @ViewChild(DxSelectBoxComponent) selectBox: DxSelectBoxComponent
  montoTotal: number = 0;
  fusEdit: any[];
  nro_fus: string = '';
  verDatos: boolean = false;
  jusReversion = false;
  observacion = false;
  rol: number;
  monto_revertido: number = 0;
  monto_fus: number = 0;
  file: File = null;
  maxFileSize = 2097152;
  typeFiles = ['application/pdf'];
  montoFus: number = 0;
  solicitudes: any[];
  fuses: any[];
  segSolicitudes: any[];
  techoId: string;
  idSolicitud: number;
  idAux: number;
  fusReversion: any;
  popupVisibleEstado: boolean = false;
  popupVisibleSeg: boolean = false;
  popupVisibleDel: boolean = false;
  popupVisibleSolicitud: boolean = false;
  popupVisibleCambiarEstado: boolean = false;
  popupVisibleR: boolean = false;
  hasError: any;
  esReversion: boolean = false;
  baseUrl = environment.apiEndpoint;
  baseUrld = environment.apiEndpoint.substring(0, environment.apiEndpoint.length - 4);
  modelSegu: any = { idSolicitud: 0, fus_id: 0, justificacion: '', estado_solicitud: '', estado_solicitud_id: 0, monto_solicitado: 0, tipo_reversion: '', tipo_reversion_id: 0, estado_id: 0, observacion: '', detalle: [] }
  estados: any[] = [{ id: 1, descripcion: 'OBSERVAR FUS' }, { id: 2, descripcion: 'REVERTIR FUS' }];
  tipo_reversion: any[] = [{ id: 1, descripcion: 'REVERSION PARCIAL' }, { id: 2, descripcion: 'REVERSION TOTAL' }];
  estadoCambiar: any[] = [{ id: 1, descripcion: 'APROBAR SOLICITUD' }, { id: 2, descripcion: 'OBSERVAR SOLICITUD' }];
  estadosFilter: any = [];
  estado: number;
  poaTecho: any;
  titulo: string = '';
  titulo_modal: string = '';
  constructor(private route: ActivatedRoute, private _sms: SolicitudModificacionService, private _fs: FusService, private _rs: ReversionService, private _gs: GeneralService) {

    let u = JSON.parse(localStorage.getItem('u'));
    this.rol = u.rol;
    this.route.paramMap.pipe(switchMap((params: ParamMap) => this.techoId = params.get('id'))).subscribe();
    this.route.paramMap.pipe(switchMap((params: ParamMap) => this.modelSegu.estado_solicitud_id = params.get('tipo'))).subscribe();
    this.getEstadoSolicitud(this.modelSegu.estado_solicitud_id);
    if (this.rol == 21) {
      this.estado = 11;
    }
    if (this.rol == 22) {
      this.estado = 11;
    }
    if (this.rol == 23) {
      this.estado = 12;
    }
    if (this.rol == 24) {
      this.estado = 14;
    }
    this.resetErrors();
    this.getEstadosByUsuario();
    this.getPoaTecho();
    this.getListFuses();

  }

  ngOnInit() {
  }

  resetErrors() {
    this.hasError = { tipo_reversion: false, estado_solicitud: false, estado_solicitud_id: false, objeto: false, justificacion: false, fus_id: false, tipo_reversion_id: false, estado_id: false, observacion: false };
  }

  getPoaTecho() {
    this._gs.getPoaTechoById(this.techoId).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) { this.poaTecho = result.data; }
        else { this.poaTecho = []; }
      },
      (error) => { console.log('Error', error); });
  }

  getEstadosByUsuario() {
    this._fs.getFusEstadosByUsuario().subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.estadosFilter = result.data;
          this.getListSolicitudesEstado(this.estado);
        }
        else { this.estadosFilter = []; }
      },
      (error) => { console.log('Error', error); });
  }

  refreshDataGrid2(e) {
    this.estado = e.value;
    this.getListSolicitudesEstado(this.estado);
  }

  getListSolicitudesEstado(estado_id: number) {
    if ((this.rol == 22) || (this.rol == 23) || (this.rol == 24)) {
      this.techoId = '0';
    }

    this._sms.getListSolicitudByEstadoId(this.techoId, estado_id, this.modelSegu.estado_solicitud_id).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.solicitudes = result.data;
        }
        else { this.solicitudes = []; }
      },
      (error) => { console.log('Error', error); });
  }

  getListFuses() {
    this._sms.getListFusSolicitud(this.techoId, this.modelSegu.estado_solicitud_id).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.fuses = result.data;
        }
        else { this.solicitudes = []; }
      },
      (error) => { console.log('Error', error); });
  }

  getDatosFus(e: any) {
    this.monto_revertido = 0;
    this.monto_fus = 0;
    if (e.value != undefined && e.value != null && this.idAux != e.value) {
      this.modelSegu.fus_id = parseInt(e.value);
      this.idAux = parseInt(e.value);
      this._sms.getDatosFusById(e.value, this.modelSegu.estado_solicitud_id).subscribe(
        (response) => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            
            this.monto_fus = result.data.monto_fus;
            this.monto_revertido = result.data.monto_revertido;
            this.fusEdit = result.data;
            this.modelSegu.detalle = result.data;
          }
        },
        (error) => { console.log('Error', error); });
    }
  }

  showModalDelete(id: number) {
    this.idSolicitud = id;
    this.popupVisibleDel = true;
  }

  getEnviarSolicitud(id: number, estado_id: number) {
    this.getEstadoSolicitud(this.modelSegu.estado_solicitud_id);
    this.modelSegu.idSolicitud = id;
    this.modelSegu.estado_id = estado_id;
    this.modelSegu.observacion = '';
    this.popupVisibleEstado = true;

  }

  getShowModalCambiarEstado(id: number, estado_id: number) {
    this.resetErrors();
    //this.modelSegu.estado_solicitud_id = 0;
    this.modelSegu.idSolicitud = id;
    this.modelSegu.estado_id = estado_id;
    this.modelSegu.observacion = '';
    this.popupVisibleCambiarEstado = true;
  }

  deleteSolicitud() {
    this._sms.deleteSolicitud(this.idSolicitud).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.popupVisibleDel = false;
          this.refreshDataGrid2(this.estado);
          toastr.success('Operación realizada exitosamente.');
        } else if (result.status == 201) {
          this.popupVisibleDel = false;
          this.refreshDataGrid2(this.estado);
          toastr.success('Operación realizada exitosamente.');
        } else {
          toastr.warning(result.data);
        }
      },
      error => { console.log('Error', error); });
  }

  onToolbarPreparing(e) {
    e.toolbarOptions.items.unshift({
      location: 'before',
      template: 'acciones'
    },
      {
        location: 'before',
        widget: 'dxButton',
        options: {
          icon: 'refresh',
          text: 'Actualizar',
          onClick: this.refreshDataGrid2.bind(this)
        }
      });
  }

  showModalAdd() {
    this.getEstadoSolicitud(this.modelSegu.estado_solicitud_id);
    this.modelSegu.idSolicitud = 0;
    this.modelSegu.justificacion = '';
    this.modelSegu.monto_solicitado = '';
    this.modelSegu.monto_solicitado = 0;
    this.modelSegu.tipo_reversion_id = 0;
    this.modelSegu.observacion = '';
    this.modelSegu.fus_id = 0;
    this.modelSegu.tipo_reversion = '';
    this.verDatos = false;
    this.popupVisibleSolicitud = true;
  }

  getEstadoSolicitud(estadoSol_id) {

    if (estadoSol_id == 2) {
      this.titulo = 'Lista de Solicitudes de Reversión';
      this.titulo_modal = 'Solicitud de Reversión FUS';
      this.modelSegu.estado_solicitud = 'REVERTIR';
      this.esReversion = true;
    }
    else if (estadoSol_id == 1) {
      this.titulo = 'Lista de Solicitudes de Observación';
      this.titulo_modal = 'Solicitud de Observación FUS';
      this.modelSegu.estado_solicitud = 'OBSERVAR';
      this.esReversion = false;
    } else if (estadoSol_id == 3) {
      this.titulo = 'Incremetar Monto FUS';
      this.titulo_modal = 'Incremetar Monto FUS';
      this.modelSegu.estado_solicitud = 'INCREMENTAR';
      this.esReversion = true;
    }

  }

  getDatosSolicitudDetalle(idSolicitud: number, idFus: number) {
    this._sms.getDatosSolicitudDetalle(idSolicitud, idFus).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.fusEdit = result.data;
          this.modelSegu.detalle = this.fusEdit;
        }
      },
      (error) => { console.log('Error', error); });
  }

  popupVisibleEditSolicitud(data: any, ver: string) {
    this.resetErrors();
    if (ver == '1')
      this.verDatos = true;
    else
      this.verDatos = false;
    this.modelSegu.justificacion = data.justificacion;

    this.getEstadoSolicitud(this.modelSegu.estado_solicitud_id);
    this.modelSegu.idSolicitud = data.id;
    this.idAux = parseInt(data.fus_id);
    this.modelSegu.fus_id = this.idAux;
    if ((this.modelSegu.estado_solicitud_id == 2) || (this.modelSegu.estado_solicitud_id == 3)) {
      this.getDatosSolicitudDetalle(this.modelSegu.idSolicitud, this.idAux);
    }
    if (data.tipo_reversion == 'REVERSION TOTAL') {
      this.modelSegu.tipo_reversion_id = 2;
      this.modelSegu.tipo_reversion = 'REVERSION TOTAL';
    }
    else {
      this.modelSegu.tipo_reversion_id = 1
      this.modelSegu.tipo_reversion = 'REVERSION PARCIAL';
    }

    this.popupVisibleSolicitud = true;
  }


  saveSolicitud() {
    if (this.validSeguimiento()) {
      this.modelSegu.monto_solicitado = this.montoTotal;
      if (this.modelSegu.estado_solicitud_id == 1) {
        this.modelSegu.monto_solicitado = 0;
        this.modelSegu.tipo_reversion = '';
        this.modelSegu.tipo_reversion_id = 0;
        this.modelSegu.detalle = [];
      }
      if (this.modelSegu.estado_solicitud_id == 3)
        this.modelSegu.tipo_reversion = '';

      if (this.modelSegu.idSolicitud == 0) {
        this._sms.postFusSolicitud(this.modelSegu).subscribe(
          response => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) {
              this.getListSolicitudesEstado(this.estado);
              this.popupVisibleSolicitud = false;
              this.fusEdit = [];
              toastr.success('Datos guardados correctamente.');
            }
            else if (result.status == 201) {
              toastr.warning(response.data);
            }
          },
          (error) => { console.log('Error', error); });
      }
      else {
        this._sms.putFusSolicitud(this.modelSegu).subscribe(
          response => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) {

              this.popupVisibleSolicitud = false;
              this.getListSolicitudesEstado(this.estado);
              toastr.success('Datos guardados correctamente.');
            } else {
              toastr.warning(result.data);
            }
          },
          error => { console.log('Error', error); });
      }

    } else {
      toastr.warning('Complete el formulario');
    }
  }

  aprobarEstado() {
    if (this.validCambioEstado()) {
      this._sms.putCambiosEstadoSolicitud(this.modelSegu).subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.popupVisibleCambiarEstado = false;
            this.getListSolicitudesEstado(this.estado);
            toastr.success('Datos guardados correctamente.');
          }
          else if (result.status == 201) {
            toastr.warning(response.data);
          }
        },
        (error) => { console.log('Error', error); });
    }
    else {
      toastr.warning('Debe Completar el formulario');
    }
  }

  enviarARevision() {
    this._sms.putCambiosEstadoSolicitud(this.modelSegu).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.popupVisibleEstado = false;
          this.getListSolicitudesEstado(this.estado);
          toastr.success('Datos guardados correctamente.');
        }
        else if (result.status == 201) {
          toastr.warning(response.data);
        }
      },
      (error) => { console.log('Error', error); });

  }
  validCambioEstado() {
    let res = true;
    if (this.modelSegu.observacion == '') {
      this.hasError.observacion = true; res = false;
    }
    if (!UtilHelper.validator(this.modelSegu.estado_id, 0)) {
      this.hasError.estado_id = true; res = false;
    }
    return res;
  }

  validSeguimiento() {
    let res = true, f1, total = 0;
    if (!UtilHelper.validator(this.modelSegu.justificacion, 'text')) {
      this.hasError.justificacion = true; res = false;
    }
    if (!UtilHelper.validator(this.modelSegu.estado_solicitud_id, 0)) {
      this.hasError.estado_solicitud_id = true; res = false;
    }
    if (this.modelSegu.estado_solicitud_id == 2) {
      if ((!UtilHelper.validator(this.modelSegu.tipo_reversion_id, 0) || (this.modelSegu.tipo_reversion_id == 0))) {
        this.hasError.tipo_reversion_id = true; res = false;
      }
    }

    if (this.esReversion == true) {
      this.modelSegu.detalle.forEach(item => {
        total = total + parseFloat(item.monto_solicitado);
      });

      this.montoTotal = total
      if ((this.montoTotal <= 0))
        f1 = true;
      if (f1) {
        res = false;
        toastr.warning('Los montos no pueden ser ceros');
      }
    }
    return res;
  }

  getTieneObservacion(e: any) {
    if (e.value == 2) {
      this.modelSegu.observacion = '';
    }
    else
      this.modelSegu.observacion = 'NINGUNA';
  }

  getTipoReversion(e: any) {
    if (e.value == 1) {
      this.modelSegu.tipo_reversion = 'REVERSION PARCIAL';
      this.modelSegu.detalle.forEach(item => {
        item.monto_solicitado = 0;
      });
    }
    if (e.value == 2) {
      this.modelSegu.tipo_reversion = 'REVERSION TOTAL';
      this.modelSegu.detalle.forEach(item => {
        item.monto_solicitado = item.monto_total_revertir;
      });
    }
  }



  handleFileInput(files: FileList) {
    this.file = files.item(0);
    if (this.file != null) {
      if (this.file.size > this.maxFileSize) {
        toastr.warning('El tamaño del archivo no debe exceder los 2MB.');
      }
      if (this.typeFiles.indexOf(this.file.type) == -1) {
        toastr.warning('Formato de archivo no válido, los permitidos son PDF.');
      }
    }
  }


  getFusReversionesById(data: any) {
    this.resetErrors();
    this.idSolicitud = parseInt(data.id);
    this.modelSegu.idSolicitud = this.idSolicitud;
    this._rs.getFusReversionesPorModById(data.fus_id, data.id).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.monto_fus = result.data.total_fus;
          this.fusReversion = result.data;
          this.fusReversion.justifica_reversion = data.justificacion;
          this.modelSegu.estado_id = 0;
          this.popupVisibleR = true;
        }
      },
      (error) => { console.log('Error', error); });
  }

  saveReversion() {
    this.jusReversion = false;
    this.observacion = false;
    if (this.validRev()) {
      if (this.modelSegu.estado_id == 2) {
        this.aprobarEstado();
        this.getListSolicitudesEstado(this.estado);
        this.popupVisibleR = false;
      }
      else {
        this._rs.postFusReversion(this.fusReversion).subscribe(
          response => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) {
              this.aprobarEstado();
              this.getListSolicitudesEstado(this.estado);
              this.popupVisibleR = false;
            }
          });
      }
    }
  }

  validRev() {
    let res = true, f1 = false, f2 = false, f3 = false, f4 = false, total: number;
    if (!UtilHelper.validator(this.fusReversion.justifica_reversion, 'text')) {
      f1 = true;;
    }
    this.fusReversion.detalle.forEach(item => {
      if ((item.revertido <= 0))
        f2 = true;
    });

    if (this.modelSegu.observacion == '') {
      this.hasError.observacion = true; f3 = true;
    }
    if (this.modelSegu.estado_id == 0) {
      this.hasError.estado_id = true; f4 = true; res = false;
    }

    if (this.modelSegu.estado_id == 1) {
      if (f2) {
        res = false;
        toastr.warning('Los montos no pueden ser ceros');
      }
    }
    if (f1) {
      res = false;
      toastr.warning('Complete la justificación');
    }
    if (f4) {
      res = false;
      toastr.warning('Elija un estado');
    }
    if (f3) {
      res = false;
      toastr.warning('Ingrese una observación');
    }



    return res;
  }

  showModalSeg(id: string, fus: string) {
    this.nro_fus = fus;
    this._sms.getSeguimientoBySolicitudId(id).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.segSolicitudes = result.data;
        }
      },
      (error) => { console.log('Error', error); });
    this.popupVisibleSeg = true;
  }

  getObservacion() {
    if (this.modelSegu.estado_id == 1)
      this.modelSegu.observacion = 'NINGUNA';
    else
      this.modelSegu.observacion = '';
  }
}
